import AddIcon from '@mui/icons-material/AddRounded'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useCallback, useEffect, useState } from 'react'
import usePageTitle from '../../util/usePageTitle'
import { useNavigate } from 'react-router-dom'
import PageContainer from '../../components/layout/PageContainer'
import useRequireAuth from '../../util/auth/useRequireAuth'
import useStore from '../../util/store/auth'
import AuditConfigPreview from './AuditConfigPreview'
import { RAuditConfig } from '@counsel-project/counsel-audit-backend-api'
import { auditBackendRequest } from '../../util/api/audit-backend-api'
import checkToken from '../../util/auth/checkToken'
import handleError from '../../util/handleError'

const ConfigureCriteria = () => {
  usePageTitle('Configure')
  useRequireAuth('/configure/criteria')

  const { directory } = useStore()
  const navigate = useNavigate()

  const [configs, setConfigs] = useState<RAuditConfig[]>([])

  const handlePopulateConfigs = useCallback(async () => {
    try {
      if (!directory) return

      const token = await checkToken()
      if (!token) return

      const { results } = await auditBackendRequest.auditConfigs.list({
        directoryId: directory?._id,
        token: '',
      })

      setConfigs(results)
    } catch (err) {
      handleError(err)
    }
  }, [directory])

  useEffect(() => {
    const timeout = setTimeout(() => {
      handlePopulateConfigs()
    }, 10)

    return () => clearTimeout(timeout)
  }, [handlePopulateConfigs])

  const handleEditConfig = (config: RAuditConfig) => {
    navigate(`/configure/${config._id}`)
  }

  const handleNavNew = () => {
    navigate('/configure/new')
  }

  return (
    <PageContainer>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" textAlign="center">
            Compliance Configuration
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary">
            For {directory?.name}
          </Typography>
        </Grid>
        {configs.map((config) => (
          <Grid item xs={12} lg={8} key={config._id}>
            <AuditConfigPreview auditConfig={config} onClick={handleEditConfig} />
          </Grid>
        ))}
        <Grid item xs={12} lg={8}>
          <Button
            sx={{ p: 3 }}
            color="primary"
            fullWidth
            startIcon={<AddIcon />}
            onClick={handleNavNew}
            data-qa-id="config-add-configuration-button"
          >
            Add New Configuration
          </Button>
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default ConfigureCriteria
